// Agrément document of a media organization (media_organizations.agreement_url,
// private `media-documents` bucket). The database is the authority, from the
// media app's migration 20260929180000_org_agreement_document.sql:
//  - the bucket accepts only PDF / JPEG / PNG, 10 MB at most;
//  - granting the agrément (is_approved false → true) without a document
//    raises ORG_AGREEMENT_REQUIRED.
// These helpers mirror it so staff get a clear message instead of a raw error.

export const AGREEMENT_MAX_BYTES = 10 * 1024 * 1024;
export const AGREEMENT_ACCEPT = "application/pdf,image/jpeg,image/png";

type Ext = "pdf" | "jpg" | "png";
const BY_TYPE: Record<string, Ext> = {
  "application/pdf": "pdf",
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/png": "png",
};
const BY_EXT: Record<string, Ext> = { pdf: "pdf", jpg: "jpg", jpeg: "jpg", png: "png" };
const CONTENT_TYPE: Record<Ext, string> = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  png: "image/png",
};

export type AgreementUploadCheck =
  | { ok: true; ext: Ext; contentType: string }
  | { ok: false; reason: "type" | "size" };

export function agreementUploadCheck(file: {
  name: string;
  type: string;
  size: number;
}): AgreementUploadCheck {
  const type = file.type.split(";")[0].trim().toLowerCase();
  const dot = file.name.lastIndexOf(".");
  const nameExt = dot >= 0 ? file.name.slice(dot + 1).toLowerCase() : "";
  const ext = type ? BY_TYPE[type] : BY_EXT[nameExt];
  if (!ext) return { ok: false, reason: "type" };
  if (file.size <= 0 || file.size > AGREEMENT_MAX_BYTES) return { ok: false, reason: "size" };
  return { ok: true, ext, contentType: CONTENT_TYPE[ext] };
}

export function canGrantAgreement(org: { agreement_url?: string | null }): boolean {
  return !!org.agreement_url?.trim();
}

export function isAgreementRequiredError(err: unknown): boolean {
  const message = (err as { message?: unknown } | null)?.message;
  return typeof message === "string" && message.includes("ORG_AGREEMENT_REQUIRED");
}
